import { Branding, useStateManager } from "@bcm-dev/bcms-vite";
import CountriesCustomSelect from "components/custom-ui/CountriesCustomSelect";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import StatesCustomSelect from "components/custom-ui/StatesCustomSelect";
import { FormRowView } from "components/shared";
import { UITextInput } from "components/ui";
import React from "react";

/**
 * @function FinancialInstitutionForm
 * @returns {React.Component}
 * @description Shared financial institution form component that is used in the DomesticDetailsFormView and the InternationalDetailsFormView components for the PayeeDetailsPage.
 */
export default function FinancialInstitutionForm(props) {
  const { data, onChange } = useStateManager();
  const payee = data.payee ?? {};
  const formType = props.formType ?? "payeeFinancialInstitution";

  return (
    <>
      { formType === "payeeFinancialInstitution" &&
        <div className="financial-institution-form">
        <FormRowView text="* Institution Number Type">
          <CustomSelect value={ payee.financialInstitutionNumberType } dataPoint="Payee_Details_Institution_Number_Type_Select" onChange={ onChange("financialInstitutionNumberType") }>
            <CustomSelectItem value="aba" dataPoint="Payee_Details_Institution_Number_Type_Option_ABA">ABA</CustomSelectItem>
          </CustomSelect>
        </FormRowView>
        <FormRowView text="* Institution Name">
            <UITextInput value={ payee.financialInstitutionName } dataPoint="Payee_Details_Institution_Name_Input" onChange={ onChange("financialInstitutionName") } />
        </FormRowView>
        <FormRowView text="* Institution Number">
            <UITextInput value={ payee.financialInstitutionNumber } dataPoint="Payee_Details_Institution_Number_Input" onChange={ onChange("financialInstitutionNumber") } />
        </FormRowView>
        <FormRowView text={ <><span className="address-line-one-asterisk hide">*</span> Address Line 1</> }>
            <UITextInput value={ payee.financialInstitutionAddressLine1 } dataPoint="Payee_Details_Institution_Address_Line_1_Input" onChange={ onChange("financialInstitutionAddressLine1") } />
        </FormRowView>
        <FormRowView text="Address Line 2">
            <UITextInput value={ payee.financialInstitutionAddressLine2 } dataPoint="Payee_Details_Institution_Address_Line_2_Input" onChange={ onChange("financialInstitutionAddressLine2") } />
        </FormRowView>
        <FormRowView text={ <><span className="city-asterisk hide">*</span> City</> }>
            <UITextInput value={ payee.financialInstitutionCity } dataPoint="Payee_Details_Institution_City_Input" onChange={ onChange("financialInstitutionCity") } />
        </FormRowView>
        { payee.payeeType === "domestic" &&
        <>
          <FormRowView text={ <><span className="state-asterisk hide">*</span> State</> }>
            <StatesCustomSelect value={ payee.financialInstitutionState } dataPoint="Payee_Details_Institution_State_Select" onChange={ onChange("financialInstitutionState") }/>
          </FormRowView>
          <FormRowView text={ <><span className="zip-code-asterisk hide">*</span> ZIP Code</> }>
              <UITextInput value={ payee.financialInstitutionZip } dataPoint="Payee_Details_Institution_Zip_Code_Input" onChange={ onChange("financialInstitutionZip") } />
          </FormRowView>
          <Branding id="beneficiaryref_abi22" value="true">
            <FormRowView text="Beneficiary Reference">
                <UITextInput value={ payee.financialInstitutionBeneficiaryReference } dataPoint="Payee_Details_Institution_Beneficiary_Reference_Input" onChange={ onChange("financialInstitutionBeneficiaryReference") } />
            </FormRowView>
          </Branding>
          <Branding id="messagetobeneficiary_abi22" value="true">
            <FormRowView className="message-to-beneficary-row" text="Message to Beneficiary">
                <UITextInput value={ payee.financialInstitutionMessageToBeneficiary1 } onChange={ onChange("financialInstitutionMessageToBeneficiary1") } />
                <UITextInput value={ payee.financialInstitutionMessageToBeneficiary2 } onChange={ onChange("financialInstitutionMessageToBeneficiary2") } />
                <UITextInput value={ payee.financialInstitutionMessageToBeneficiary3 } onChange={ onChange("financialInstitutionMessageToBeneficiary3") } />
                <UITextInput value={ payee.financialInstitutionMessageToBeneficiary4 } onChange={ onChange("financialInstitutionMessageToBeneficiary4") } />
            </FormRowView>
          </Branding>
        </>
        }
        { payee.payeeType === "international" &&
        <>
          <FormRowView text="State or Province">
            <UITextInput value={ payee.financialInstitutionStateOrProvidence } onChange={ onChange("financialInstitutionStateOrProvidence") }/>
          </FormRowView>
          <FormRowView text="Postal Code">
              <UITextInput value={ payee.financialInstitutionPostalCode } onChange={ onChange("financialInstitutionPostalCode") }/>
          </FormRowView>
          <FormRowView text="* Country">
          <CountriesCustomSelect value={ payee.financialInstitutionCountry } onChange={ onChange("financialInstitutionCountry") }/>
        </FormRowView>
        </>
        }
      </div>
    }
    { formType === "receivingFinancialInstitution" &&
        <div className="financial-institution-form">
        <FormRowView text="* Institution Number Type">
          <CustomSelect value={ payee.receivingInstitutionNumberType } onChange={ onChange("receivingInstitutionNumberType") }>
            <CustomSelectItem value="aba">ABA</CustomSelectItem>
          </CustomSelect>
        </FormRowView>
        <FormRowView text="* Institution Name">
            <UITextInput value={ payee.receivingInstitutionName } onChange={ onChange("receivingInstitutionName") } />
        </FormRowView>
        <FormRowView text="* Institution Number">
            <UITextInput value={ payee.receivingInstitutionNumber } onChange={ onChange("receivingInstitutionNumber") }/>
        </FormRowView>
        <FormRowView text="Address Line 1">
            <UITextInput value={ payee.receivingInstitutionAddressLine1 } onChange={ onChange("receivingInstitutionAddressLine1") } />
        </FormRowView>
        <FormRowView text="Address Line 2">
            <UITextInput value={ payee.receivingInstitutionAddressLine2 } onChange={ onChange("receivingInstitutionAddressLine2") }/>
        </FormRowView>
        <FormRowView text="City">
            <UITextInput value={ payee.receivingInstitutionCity } onChange={ onChange("receivingInstitutionCity") }/>
        </FormRowView>
        { payee.payeeType === "domestic" &&
        <>
          <FormRowView text="State">
            <StatesCustomSelect value={ payee.receivingInstitutionState } onChange={ onChange("receivingInstitutionState") }/>
          </FormRowView>
          <FormRowView text="ZIP Code">
              <UITextInput value={ payee.receivingInstitutionZip } onChange={ onChange("receivingInstitutionZip") } />
          </FormRowView>
        </>
        }
        { payee.payeeType === "international" &&
        <>
          <FormRowView text="State or Province">
            <UITextInput value={ payee.receivingInstitutionStateOrProvidence } onChange={ onChange("receivingInstitutionStateOrProvidence") }/>
          </FormRowView>
          <FormRowView text="Postal Code">
              <UITextInput value={ payee.receivingInstitutionPostalCode } onChange={ onChange("receivingInstitutionPostalCode") }/>
          </FormRowView>
          <FormRowView text="* Country">
          <CountriesCustomSelect value={ payee.receivingInstitutionCountry } onChange={ onChange("receivingInstitutionCountry") }/>
        </FormRowView>
        </>
        }
      </div>
    }
    { formType === "intermediaryFinancialInstitution" &&
        <div className="financial-institution-form">
        <FormRowView text="* Institution Number Type">
          <CustomSelect value={ payee.intermediaryInstitutionNumberType }>
            <CustomSelectItem value="aba">ABA</CustomSelectItem>
          </CustomSelect>
        </FormRowView>
        <FormRowView text="* Institution Name">
            <UITextInput value={ payee.intermediaryInstitutionName } onChange={ onChange("intermediaryInstitutionName") }/>
        </FormRowView>
        <FormRowView text="* Institution Number">
            <UITextInput value={ payee.intermediaryInstitutionNumber } onChange={ onChange("intermediaryInstitutionNumber") }/>
        </FormRowView>
        <FormRowView text="Address Line 1">
            <UITextInput value={ payee.intermediaryInstitutionAddressLine1 } onChange={ onChange("intermediaryInstitutionAddressLine1") }/>
        </FormRowView>
        <FormRowView text="Address Line 2">
            <UITextInput value={ payee.intermediaryInstitutionAddressLine2 } onChange={ onChange("intermediaryInstitutionAddressLine2") }/>
        </FormRowView>
        <FormRowView text="City">
            <UITextInput value={ payee.intermediaryInstitutionCity } onChange={ onChange("intermediaryInstitutionCity") }/>
        </FormRowView>
        { payee.payeeType === "domestic" &&
        <>
          <FormRowView text="State">
            <StatesCustomSelect value={ payee.intermediaryInstitutionState } onChange={ onChange("intermediaryInstitutionState") }/>
          </FormRowView>
          <FormRowView text="ZIP Code">
              <UITextInput value={ payee.intermediaryInstitutionZip } onChange={ onChange("intermediaryInstitutionZip") } />
          </FormRowView>
        </>
        }
        { payee.payeeType === "international" &&
        <>
          <FormRowView text="State or Province">
            <UITextInput value={ payee.intermediaryInstitutionStateOrProvidence } onChange={ onChange("intermediaryInstitutionStateOrProvidence") }/>
          </FormRowView>
          <FormRowView text="Postal Code">
              <UITextInput value={ payee.intermediaryInstitutionPostalCode } onChange={ onChange("intermediaryInstitutionPostalCode") }/>
          </FormRowView>
          <FormRowView text="* Country">
            <CountriesCustomSelect value={ payee.intermediaryInstitutionCountry } onChange={ onChange("intermediaryInstitutionCountry") }/>
          </FormRowView>
        </>
        }
      </div>
    }
  </>
  )

}